import { Group, Select } from "@mantine/core";
import {
  PAYMENT_MODE_FILTER_OPTIONS,
  TRANSACTION_TYPE_FILTER_OPTIONS,
} from "../../utils/transaction";
import classes from "./WalletTransactionToolbar.module.css";

const H = 44;

const selectStyles = {
  input: { paddingInlineEnd: "2.35rem" },
};

const WalletTransactionToolbar = ({
  paymentModeFilter,
  onPaymentModeChange,
  transactionTypeFilter,
  onTransactionTypeChange,
}) => (
  <Group gap="sm" wrap="nowrap" align="center" className={classes.toolbarMain}>
    <Select
      placeholder="All Payment Modes"
      data={PAYMENT_MODE_FILTER_OPTIONS}
      value={paymentModeFilter || null}
      onChange={(value) => onPaymentModeChange(value ?? "")}
      className={classes.filterSelectWide}
      h={H}
      clearable
      searchable={false}
      styles={selectStyles}
    />
    <Select
      placeholder="All Types"
      data={TRANSACTION_TYPE_FILTER_OPTIONS}
      value={transactionTypeFilter || null}
      onChange={(value) => onTransactionTypeChange(value ?? "")}
      className={classes.filterSelect}
      h={H}
      clearable
      searchable={false}
      styles={selectStyles}
    />
  </Group>
);

export default WalletTransactionToolbar;
